const segmentField = $('.js_segment_field');
const billingField = $('.js_billing_group_field');

if (segmentField && billingField) {
    segmentField.on('select2:select', function (e) {
        const selectedOption = e.params.data.element;
        billingField.val(selectedOption.dataset.billing);
        billingField.trigger('change.select2');
    });
}